import { IntercomActionTypes } from './types';
import { createAsyncMapAction } from '~lib/shared/redux/actions';
export const getHash = createAsyncMapAction(IntercomActionTypes.GET_HASH, p => p.userId);
export const getConversation = createAsyncMapAction(IntercomActionTypes.GET_CONVERSATION, p => p.conversationId);
